// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// COMPONENTS
import SelectCurrency from 'components/inputs/SelectCurrency';
import DateInput from 'components/inputs/DateInput';
import ContractTypeInput from 'components/inputs/ContractTypeInput';
import Col from 'components/common/Col';
import Row from 'components/common/Row';
import moment, { isMoment } from 'moment';

const StyledRow = styled(Row)`
  width: 500px;
  margin: auto;
  max-width: 100%;
`;
const StyledCol = styled(Col)`
  margin-bottom: 15px;
`;

class ClientInfo extends React.Component {
  render() {
    return (
      <StyledRow>
        <StyledCol xs={24}>
          <ContractTypeInput
            onChange={contractType => this.props.onChange({ contractType })}
            initialValue={this.props.contract && this.props.contract.contractType}
          />
        </StyledCol>
        <StyledCol xs={12} sm={12}>
          <DateInput
            onChange={sessionDate => this.props.onChange({ sessionDate })}
            value={this.props.contract.sessionDate}
          />
        </StyledCol>
        <StyledCol xs={12} sm={12}>
          <SelectCurrency
            onChange={currency => this.props.onChange({ currency })}
            value={this.props.contract.currency}
          />
        </StyledCol>
      </StyledRow>
    );
  }
}

export default ClientInfo;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/ClientInfo/index.js